import DataAsesmenRalan from "@/services/DataAsesmenRalan";
import { IdentitasPasien } from "@/types";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";
import DataNyeri from "@/services/DataNyeri";
import AsesNyeriSvc from "@/services/AsesmenNyeri";

// interface Nyeri {
//   unit_id: number;
//   register_id: number;
//   tanda_vital: object;
//   antropometri: object;
//   nyeri: object;
// }

let nyeriRegister: string = null;
let nyeriRegisterToken = 0;
let nyeriRm: string = null;
let nyeriRmToken = 0;

@Module({ store, dynamic: true, name: "storeNyeri" })
class StoreNyeri extends VuexModule {
  detailnyeri = [];
  nyeri = [];
  inputNyeri = null;
  savingNyeri = false;

  @Mutation SET_DETAIL_NYERI(detailnyeri) {
    this.detailnyeri = detailnyeri;
  }
  @Mutation SET_NYERI(nyeri = []) {
    this.nyeri = nyeri;
  }
  @Mutation SET_INPUT_NYERI(params = null) {
    this.nyeri = params;
  }
  @Mutation SET_SAVING_NYERI(val) {
    this.savingNyeri = val;
  }
  @Mutation CLEAR_STORE() {
    this.detailnyeri = [];
    this.nyeri = [];
    this.inputNyeri = null;
  }

  @Action actNyeriByReg(param) {
    const unit = param["unit_id"];
    const reg = param["reg"];
    const key = `${unit}:${reg}`;
    const token = ++nyeriRegisterToken;

    if (nyeriRegister !== key) {
      this.SET_DETAIL_NYERI([]);
    }
    nyeriRegister = key;

    const dt = DataNyeri.getDataNyeriByReg(unit, reg);
    appModule.setLoading(true);

    dt.then(dt => {
      appModule.setLoading(false);
      if (token !== nyeriRegisterToken) return;

      this.SET_DETAIL_NYERI(Array.isArray(dt?.data) ? dt.data : []);
    });
  }
  @Action actNyeriByRm(rm) {
    const token = ++nyeriRmToken;

    if (nyeriRm !== String(rm)) {
      this.SET_NYERI([]);
    }
    nyeriRm = String(rm);

    const dt = DataNyeri.getDataNyeri(rm);
    appModule.setLoading(true);
    dt.then(dt => {
      appModule.setLoading(false);
      if (token !== nyeriRmToken) return;

      this.SET_NYERI(Array.isArray(dt?.data) ? dt.data : []);
    });
  }
  @Action reset() {
    nyeriRegister = null;
    nyeriRm = null;
    nyeriRegisterToken++;
    nyeriRmToken++;
    this.CLEAR_STORE();
  }
  @Action saveNyeri() {
    this.SET_SAVING_NYERI(true);

    const SaveNyeri = this.inputNyeri?.id
      ? AsesNyeriSvc.update(this.inputNyeri.id, this.inputNyeri)
      : AsesNyeriSvc.create(this.inputNyeri);

    const resp = SaveNyeri.then(resp => {
      return resp;
    })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.SET_SAVING_NYERI(false);
      });

    return resp;
  }
}

export const storeNyeri = getModule(StoreNyeri);

